import Logger from "logger/logger"
import React, {useEffect} from "react"
import {ToastContainer} from "react-toastify"
import EnvironmentService, {subscribeEnv} from "app/Service/System/EnvironmentService"

function ToastController() {

  const {themeMode} = EnvironmentService([
    subscribeEnv.themeMode
  ], 'ToastController')

  useEffect(function ToastControllerInit() {
    Logger('Controller.Toast.init')
    return () => {
      Logger('Controller.Toast.unloading')
    }
  }, [])

  return <ToastContainer newestOnTop={true} theme={themeMode}/>
}

export default ToastController
